import { CSSProperties, FC, useState } from "react";
import clsx from "classnames";
import {
  getYtbVideoIframeUrl,
  getYtbVideoThumbnail,
  YtbThumbnailQuality,
} from "../../../models/media";
import { useStyles } from "./YtbVideoPlayer.style";

interface IYtbVideoPlayerProps {
  url: string;
  autoplay?: boolean;
  loop?: boolean;
  title?: string;
  className?: string;
  style?: CSSProperties;
  onError?: () => void;
  thumbnailQuality?: YtbThumbnailQuality;
}

export const YtbVideoPlayer: FC<IYtbVideoPlayerProps> = ({
  url,
  autoplay = true,
  loop = true,
  title,
  className,
  style,
  onError,
  thumbnailQuality = "sd",
}) => {
  const classes = useStyles();
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={clsx(classes.wrapper, className)} style={style}>
      <img
        src={getYtbVideoThumbnail(url, thumbnailQuality)}
        className={classes.thumbnail}
        alt=""
      />
      <iframe
        src={getYtbVideoIframeUrl(url, {
          autoplay,
          loop
        })}
        className={clsx(
          classes.iframe,
          isLoaded && classes.iframeLoaded,
        )}
        onLoad={() => setIsLoaded(true)}
        onError={onError}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </div>
  );
};
